import { ReactNode } from "react";
import { Fab, Tooltip, styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

type Props = {
  onClick?: () => void;
  tooltip: string;
  icon?: ReactNode;
  /** Distance in px from the viewport bottom; allows stacking multiple FABs. */
  bottom?: number;
};

const StyledFab = styled(Fab)({
  margin: 0,
  top: "auto",
  right: 20,
  left: "auto",
  position: "fixed",
});

const AddFloatingActionButton = ({ onClick, tooltip, icon, bottom = 20 }: Props) => {
  return (
    <Tooltip title={tooltip} placement="left">
      <StyledFab
        onClick={() => onClick?.()}
        color="primary"
        aria-label={tooltip}
        sx={{ bottom }}
      >
        {icon ?? <AddIcon />}
      </StyledFab>
    </Tooltip>
  );
};

export default AddFloatingActionButton;
